import { tw } from "@careinfo/tailwind";
import {
  FieldValue,
  FieldValues,
  UseFormGetValues,
  UseFormSetValue,
  UseFormWatch,
} from "react-hook-form";
import Datepicker from "../DatePicker";

interface Props<T extends FieldValues> {
  label: string;
  setValue: UseFormSetValue<T>;
  getValues: UseFormGetValues<T>;
  name: FieldValue<T>;
}
const DateRangePicker = <T extends FieldValues>({
  label,
  setValue,
  name,
  getValues,
}: Props<T>) => {
  const handleValueChange = (newValue: any) => {
    if (newValue?.startDate && newValue.endDate) {
      const formatDate = (date: Date) => {
        return date.toISOString().split("T")[0];
      };

      const startDate = new Date(newValue?.startDate);
      const endDate = new Date(newValue?.endDate);

      const formattedStartDate = formatDate(startDate);
      const formattedEndDate = formatDate(endDate);
      // @ts-ignore  TODO: should remove later after solution
      setValue(name, `${formattedStartDate},${formattedEndDate}`);
    } else {
      // @ts-ignore  TODO: should remove later after solution
      setValue(name, "");
    }
  };
  return (
    <div className={tw``}>
      <label htmlFor="" className="">
        {label}
      </label>
      <div className={tw`mt-1`}>
        <Datepicker
          inputClassName={tw`focus:outline-none bg-[#EEF5F4] w-full p-2`}
          popoverDirection="down"
          value={{
            startDate: getValues()?.[name]?.split(",")?.[0] ?? null,
            endDate: getValues()?.[name]?.split(",")?.[1] ?? null,
          }}
          primaryColor={"pink"}
          onChange={handleValueChange}
          showShortcuts={true}
        />
      </div>
    </div>
  );
};

export default DateRangePicker;

